import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/weather/zenith.png'


const _withScopeId = n => (_pushScopeId("data-v-349b87a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weather-page crt" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import Static from '@/components/weather/Static.vue'
import Weather from '@/components/weather/Weather.vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'WeatherView',
  setup(__props) {

const tunedIn = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!tunedIn.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "tv-remote",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (tunedIn.value = !tunedIn.value))
        }, _hoisted_3))
      : _createCommentVNode("", true),
    (!tunedIn.value)
      ? (_openBlock(), _createBlock(Static, { key: 1 }))
      : (_openBlock(), _createBlock(Weather, { key: 2 }))
  ]))
}
}

})